var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"address"},[_c('van-nav-bar',{attrs:{"fixed":"","title":"收货地址","left-text":"返回","right-text":"+","left-arrow":""},on:{"click-left":_vm.onClickLeft,"click-right":_vm.onClickRight}}),_c('AddressItem',{attrs:{"list":_vm.ReceivedAddress}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }